export default "__VITE_ASSET__DpTcsyRc__"